// import RenderRowValues from '../renderRows/RenderRowValues'
import { DetailsForEachDateChannelAllocatedList } from '../../../types/inventoryAllocatedList'
import useStyles from './styles/InventoryRatePlanRowMobile.styles'

interface InventoryRatePlanRowProps {
  channelDataForEachDay: DetailsForEachDateChannelAllocatedList[]
}

const InventoryRatePlanRow: React.FC<InventoryRatePlanRowProps> = ({
  channelDataForEachDay
}) => {
  const classes = useStyles()

  return (
    <div className={classes.roomTypeRow}>
      {/* <div className={classes.rowNameContainer}>
        <Typography variant="h4" className={classes.rowName}>
          {getTranslate(name)}
        </Typography>

        <ArrowRightIcon className={[classes.channelArrowRight].join(' ')} />
      </div> */}
      {/* <div className={classes.dayContainer}>
          <Typography variant="h5">{getTranslate('AVAIL')}</Typography>
        </div> */}
      <div className={classes.avalabilitiesContainer}>
        {channelDataForEachDay?.map((item, index) => (
          <div
            key={`${index}-${item.date}`}
            className={[classes.dayContainer].join(' ')}>
            <input value={item.allocatedAvailability} />
          </div>
        ))}
      </div>
    </div>
  )
}

export default InventoryRatePlanRow
